import React from "react";
import {Layout, Menu} from "antd";
import {useLocation, useNavigate} from "react-router-dom";
import {PRODUCT_IS_PUBLIC, routers} from "../../routers/routerConfig";

const {Sider} = Layout;

const LayoutSiderMenu = ({collapsed, onCollapsed, user}) => {
    let location = useLocation()
    let navigate = useNavigate();


    const onClickMenu = (path) => {
        navigate(path)
    }

    const renderMenuItems = (items) => {
        return items.filter(item => {
            if (item.hidden) {
                return false
            }

            if (PRODUCT_IS_PUBLIC && !item.isPublic) return false
            if (!PRODUCT_IS_PUBLIC && !item.isPrivate) return false

            if (!item.auth) return true

            return (user?.properties?.accesses ?? []).indexOf(item.auth) > -1
        })
            .map(item => {
                return <Menu.Item key={item.path} icon={item.icon}
                                  onClick={e => onClickMenu(item.path)}>{item.name}</Menu.Item>
            })
    }

    const renderSubMenu = (item) => {
        if (item.children && item.children.length) {
            const children = renderMenuItems([...item.children])
            if (children.length) {
                return <Menu.SubMenu key={item.name} icon={item.icon} title={item.name}>
                    {children}
                </Menu.SubMenu>
            } else {
                return <></>
            }
        }
        return renderMenuItems([item])
    }

    return (
        <Sider theme={'light'} width={200}
               collapsible
               collapsedWidth={35}
               collapsed={collapsed}
               onCollapse={(collapsed, type) => {
                   onCollapsed(collapsed)
               }}
               breakpoint={'lg'}
               onBreakpoint={e => {
                   console.log(e)
               }}
               style={{
                   overflow: 'auto',
                   height: '100vh',
                   position: 'fixed',
                   left: 0,
                   background: "#fff"
               }}>
            <Menu
                mode="inline"
                selectedKeys={[location.pathname]}
                style={{height: '100%', borderRight: 0}}
            >
                {
                    routers.map(template => template.children.map(renderSubMenu))
                }
            </Menu>
        </Sider>
    )
}

export default LayoutSiderMenu